<div class="agpr-analysisField" [id]="locatorId">
    @if (value) {
        <div [id]="locatorId + '_generationOptions'">
            @if (!block?.displayElement?.automaticallyGenerated) {
                <agpr-radio
                    [id]="'analysis_radio_generateNow'"
                    label="Briefings.analysis.generateNow"
                    [tooltip]="'Briefings.analysis.generateNow.info'"
                    hiddenLabel="Briefings.analysis.generateNow"
                    [(ngModel)]="generateOnSend"
                    name="analysisField-generateOnSend"
                    [value]="false"
                    (ngModelChange)="setupValue()"
                ></agpr-radio>

                @if (!generateOnSend) {
                    <div
                        class="agpr-analysisField-indent"
                        [id]="locatorId + '_generateAnalysisContainer'"
                    >
                        <agpr-button
                            [id]="'generate_analysis_open_dialog_button'"
                            [icon]="'agpr-button-lighter fa-kit-duotone fa-agpr-insights'"
                            [style]="buttonTypes.tertiary"
                            [label]="'Briefings.analysis.generateAnalysis'"
                            [disabled]="isSurgePeriodSelected"
                            [tooltip]="isSurgePeriodSelected ? 'Alerts.analysis.surgePeriod.incompatible' : ''"
                            (click)="openGenerateAnalysisDialog()"
                        ></agpr-button>
                    </div>
                }

                <agpr-radio
                    [id]="'analysis_radio_generateOnSend'"
                    label="Briefings.analysis.generateOnSend"
                    [tooltip]="'Briefings.analysis.generateOnSend.info'"
                    hiddenLabel="Briefings.analysis.generateOnSend"
                    [(ngModel)]="generateOnSend"
                    name="analysisField-generateOnSend"
                    (ngModelChange)="setupValue()"
                    [value]="true"
                ></agpr-radio>
            }

            @if (generateOnSend || block?.displayElement?.automaticallyGenerated) {
                <div
                    class="agpr-analysisField-indent"
                    [id]="locatorId + '_analysisTypeContainer'"
                    [ngClass]="{'agpr-analysisField-noIndent': block?.displayElement?.automaticallyGenerated}"
                >
                    <agpr-dropdown
                        [id]="locatorId + '_analysisType'"
                        label="Briefings.analysis.analysisType"
                        [placeholder]="'Briefings.analysis.analysisType.placeholder'"
                        [options]="analysisTypeOptions"
                        [(ngModel)]="selectedAnalysisTypeOption"
                        (ngModelChange)="analysisTypeChange()"
                    >
                    </agpr-dropdown>

                    @if (!selectedAnalysisTypeOption) {
                        <agpr-form-message>
                            {{ 'Briefings.analysis.errors.mustSelectAnalysisType' | localize }}
                        </agpr-form-message>
                    }

                    @if (selectedAnalysisTypeOption?.value === coverageInsightTypes.CUSTOM) {
                        <div
                            class="agpr-analysisField-spacing"
                            [id]="locatorId + '_customAnalysisTypeContainer'"
                            [ngClass]="{'agpr-analysisField-customDropdown': openAiPermission}"
                        >
                            <agpr-dropdown
                                [id]="locatorId + '_customAnalysisType'"
                                label="Briefings.analysis.customAnalysisType"
                                [placeholder]="'Briefings.analysis.customAnalysisType.placeholder'"
                                [options]="customInsightsOptions"
                                [(ngModel)]="customInsightOption"
                                [allowNull]="true"
                                (ngModelChange)="selectCustomPrompt($event)"
                            >
                            </agpr-dropdown>
                            @if (openAiPermission) {
                                <agpr-button
                                    [id]="id + '_insight_openCustomInsight'"
                                    class="agpr-analysisField-customDropdown-setting"
                                    [style]="buttonTypes.block"
                                    icon="fa-regular fa-duotone fa-gear"
                                    tooltip="CustomPrompt.prompt.list.section.title"
                                    tooltipPosition="left"
                                    (click)="openCustoPromptDialog()"
                                ></agpr-button>
                            }

                        </div>
                        @if (!customInsightOption?.value?.id && block?.errors?.length) {
                            <agpr-form-message>
                                {{ 'Briefings.analysis.errors.customPromptIsRequired' | localize }}
                            </agpr-form-message>
                        }
                        @if (customInsightOption) {
                            <div class="agpr-analysisField-indentSmall">
                                <agpr-coverage-insights-form
                                    [value]="value"
                                    [customInsight]="customInsightOption?.value"
                                    (customFormChanged)="changedCustomValue($event)"
                                ></agpr-coverage-insights-form>
                            </div>

                            @if (customInsightSaveTooltip) {
                                <div class="agpr-analysisField-spacing">
                                    <agpr-message
                                        [severity]="messageSeverityEnum.error"
                                    >
                                        {{ customInsightSaveTooltip | localize }}
                                    </agpr-message>
                                </div>
                            }

                            <div class="agpr-analysisField-customActions">
                                <div class="agpr-analysisField-spacer"></div>

                                <agpr-button
                                    class="agpr-generateAnalysisDialog-buttonSpace"
                                    label="Briefings.analysis.customAnalysis.save"
                                    [style]="buttonTypes.tertiary"
                                    [disabled]="!customInsightValid || customInsightOption?.value?.equals(customInsightCopy)"
                                    [agprTooltip]="'Briefings.analysis.customAnalysis.save.tooltip'"
                                    [id]="id + '_insight_saveCustomInsight'"
                                    (click)="saveCustomInsight()"
                                ></agpr-button>
                                @if (customInsightOption?.value?.id) {
                                    <agpr-button
                                        class="agpr-generateAnalysisDialog-buttonSpace"
                                        label="Briefings.analysis.customAnalysis.saveAs"
                                        [style]="buttonTypes.tertiary"
                                        [disabled]="!customInsightValid"
                                        [agprTooltip]="'Briefings.analysis.customAnalysis.saveAs.tooltip'"
                                        [id]="id + '_insight_saveAsCustomInsight'"
                                        (click)="saveAsCustomInsight()"
                                    ></agpr-button>
                                }
                            </div>
                        }
                    } @else {
                        <div class="agpr-analysisField-indentSmall">
                            <agpr-coverage-insights-form
                                [value]="value"
                                (formChanged)="changedValue($event)"
                            ></agpr-coverage-insights-form>
                        </div>
                    }
                </div>
            }
        </div>
    }
</div>
